<div class="flex-fill pl-2 pr-2 pb-3" style="font-size: large;">Pricing Filter Values</div>
<kendo-grid #grid="kendoGrid" [data]="gridView" [pageSize]="query.PageSize" [skip]="skip" [sort]="query.SortTerm"
  [reorderable]="true" [loading]="loading" [pageable]="true" (pageChange)="pageChange($event)" [filter]="filter"
  [filterable]="filterable" (filterChange)="gridFilterChange($event)" [resizable]="true" [sortable]="true" [sort]="sort"
  (sortChange)="sortChange($event)" [selectable]="{ mode: 'multiple' }" kendoGridSelectBy="id"
  [selectedKeys]="mySelection" (cellClick)="onCellClick($event)" (dblclick)="onDblClick()">
  <ng-template kendoGridToolbarTemplate style="padding-right: 500">
    <kendo-buttongroup>
      <button kendoButton type="button" style="border: none; padding-left: 10px; padding-right: 10px;"
              imageUrl="../../../../assets/images/Refresh.png" (click)="onRefresh()" title="Refresh">
        Refresh
      </button>
      <button kendoButton type="button" id="btnAdd" class="showTooltip" style="border: none; padding-left: 10px; padding-right: 10px;"
              [disabled]="!this.pricingFilterID" imageUrl="../../../../assets/images/Add.png" (click)="onCreate()"
              title="Save the record above to be able to start adding these records here.">
        Add New
      </button>
      <button kendoButton type="button" style="border: none; padding-left: 10px; padding-right: 10px;"
              [disabled]="disableEditBtn" imageUrl="../../../../assets/images/Edit.png" (click)="onDblClick()"
              title="Edit Selected">
        Edit
      </button>
      <button kendoButton type="button" style="border: none; padding-left: 10px; padding-right: 10px;"
              [disabled]="disableDeleteBtn" imageUrl="../../../../assets/images/Delete.png"
              (click)="onClick_Delete()" title="Delete Selected">
        Delete
      </button>
      <button kendoButton type="button" style="border: none; padding-left: 10px; padding-right: 10px;"
              imageUrl="../../../../assets/images/Excel_Export.png" (click)="onClick_Export(grid, exportToExcel)"
              title="Export to Excel">
        Export
      </button>
      <button kendoButton type="button" style="border: none; padding-left: 10px; padding-right: 10px;"
              imageUrl="../../../../assets/images/Excel_Import.png" (click)="hiddenfileinput.click()"
              title="Import from Excel">
        Import
      </button>
    </kendo-buttongroup>
    <input type="file" style="display: none" (change)="onFileChange($event)" multiple="false" #hiddenfileinput />
    <kendo-grid-column-chooser [allowHideAll]="false" [autoSync]="true" style="float: right;">Columns</kendo-grid-column-chooser>
    <button kendoButton type="button" style="border: none; padding-left: 10px; padding-right: 10px;" imageUrl="../../../../assets/images/ResetGrid.png" (click)="onResetGridClick()" title="Reset Grid"></button>
    <button kendoButton type="button" style="border: none; padding-left: 10px; padding-right: 10px;" imageUrl="../../../../assets/images/FilterGrid.png" (click)="onFilterClick()" title="Filter"></button>
  </ng-template>
  <kendo-grid-column field="entity.name" title="Entity" width="300"
    [headerStyle]="{'background-color': '#666','color': '#fff','line-height': '1em'}">
    <ng-template kendoGridFilterCellTemplate let-filter>
      <entity-type-filter
        [filter]="filter"
        [data]="entityTypeOptions"
        textField="name"
        valueField="name"
      >
      </entity-type-filter>
    </ng-template>   
  </kendo-grid-column>
  <kendo-grid-column field="attribute.name" title="Attribute" width="300"
    [headerStyle]="{'background-color': '#666','color': '#fff','line-height': '1em'}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
        <kendo-filter-eq-operator></kendo-filter-eq-operator>
        <kendo-filter-neq-operator></kendo-filter-neq-operator>
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
        <kendo-filter-not-contains-operator></kendo-filter-not-contains-operator>
        <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
        <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <div *ngIf="dataItem.customerAttribute">
        {{ dataItem.customerAttribute.name }}
      </div>
      <div *ngIf="dataItem.documentAttribute">
        {{ dataItem.documentAttribute.name }}
      </div>
      <div *ngIf="dataItem.itemAttribute">
        {{ dataItem.itemAttribute.name }}
      </div>     
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="operand.name" title="Operand" width="300"
    [headerStyle]="{'background-color': '#666','color': '#fff','line-height': '1em'}">
    <ng-template kendoGridFilterCellTemplate let-filter>
      <pricing-filter-value-operand-filter [filter]="filter" [data]="pricingFilterValueOperandOptions" textField="name"
        valueField="name">
      </pricing-filter-value-operand-filter>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="value" title="Value" width="300"
    [headerStyle]="{'background-color': '#666','color': '#fff','line-height': '1em'}">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter" operator="contains">
        <kendo-filter-eq-operator></kendo-filter-eq-operator>
        <kendo-filter-neq-operator></kendo-filter-neq-operator>
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
        <kendo-filter-not-contains-operator></kendo-filter-not-contains-operator>
        <kendo-filter-startswith-operator></kendo-filter-startswith-operator>
        <kendo-filter-endswith-operator></kendo-filter-endswith-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <!-- CUSTOMER -->
      <div *ngIf="dataItem.entity.name == 'Customer'">
        {{ dataItem.displayValue }}
      </div>
      <!-- CUSTOMER ATTRIBUTE -->
      <div *ngIf="dataItem.entity.name == 'Customer Attribute' && dataItem.customerAttribute">
        {{ dataItem.value }}
      </div>
      <!-- DATE -->
      <div *ngIf="dataItem.entity.name == 'Date'">
        {{ dataItem.value }}
      </div>
      <!-- DOCUMENT -->
      <div *ngIf="dataItem.entity.name == 'Document Attribute'">
        {{ dataItem.value }}
      </div>
      <!-- ITEM -->
      <div *ngIf="dataItem.entity.name == 'Item'">
        {{ dataItem.displayValue }}
      </div>
      <!-- ITEM ATTRIBUTE -->
      <div *ngIf="dataItem.entity.name == 'Item Attribute' && dataItem.itemAttribute">
        {{ dataItem.value }}
      </div>
      <!-- LOCATION -->
      <div *ngIf="dataItem.entity.name == 'Location'">
        {{ dataItem.displayValue }}
      </div>
      <!-- UOFM -->
      <div *ngIf="dataItem.entity.name == 'UofM'">
        {{ dataItem.displayValue }}
      </div>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-excel #exportToExcel fileName="PricingFilterValues.xlsx">
    <kendo-excelexport-column field="id" title="ID" *ngIf="exportAll && optRowID"></kendo-excelexport-column>
    <kendo-excelexport-column field="pricingFilter.name" title="PricingFilterName" [headerCellOptions]="{bold:'true'}" *ngIf="exportAll">    </kendo-excelexport-column>
    <kendo-excelexport-column field="entity.name" title="EntityName" [headerCellOptions]="{bold:'true'}" *ngIf="exportAll">    </kendo-excelexport-column>
    <kendo-excelexport-column field="customerAttribute.name" title="CustomerAttributeName" *ngIf="exportAll">    </kendo-excelexport-column>
    <kendo-excelexport-column field="documentAttribute.name" title="DocumentAttributeName" *ngIf="exportAll">    </kendo-excelexport-column>
    <kendo-excelexport-column field="itemAttribute.name" title="ItemAttributeName" *ngIf="exportAll">    </kendo-excelexport-column>
    <kendo-excelexport-column field="useCurrentDate" title="UseCurrentDate" *ngIf="exportAll">    </kendo-excelexport-column>
    <kendo-excelexport-column field="operand.name" title="OperandName" [headerCellOptions]="{bold:'true'}" *ngIf="exportAll"></kendo-excelexport-column>
    <kendo-excelexport-column field="value" title="Value" *ngIf="exportAll"></kendo-excelexport-column>
  </kendo-grid-excel>
</kendo-grid>
<ng-template #loader>
  <app-spinner> </app-spinner>
</ng-template>
